const originalAuthUrl = 'originalAuthUrl';

const sessionStorageUtil = {
  getOriginalAuthUrl: () => {
    return sessionStorage.getItem(originalAuthUrl);
  },
  updateOriginalAuthUrl: (value) => {
    sessionStorage.setItem(originalAuthUrl, value);
  },
  removeOriginalAuthUrl: () => {
    sessionStorage.removeItem(originalAuthUrl);
  },
};
export default sessionStorageUtil;
